import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import XHR from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

import { PUBLIC_URL } from './constants/config'

const LOAD_PATH: string = PUBLIC_URL === '.' ? `./locales/{{lng}}.json` : '/locales/{{lng}}.json'

// eslint-disable-next-line import/no-named-as-default-member
i18next
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: LOAD_PATH,
    },
    react: {
      useSuspense: true,
    },
    fallbackLng: 'en',
    preload: ['en'],
    keySeparator: false,
    interpolation: { escapeValue: false },
  })

export default i18next
